import { borderColorLight, ColorWhite } from './palette';

export const dropDownFilterInputBorderColor = borderColorLight;
export const dropDownFilterBgColor = ColorWhite;
